import React, { useEffect, useState } from 'react';
import { getEventsFinancials } from '~/services/hooks/eventFinancials';
import errorHandler from '~/Utils/errorHandler';
import Box from '~/components/Box';
import { Table, TableHeader } from '~/components/Table';
import { Col, Input, Select, Table as TableAntd } from 'antd';
import Pagination from '~/components/Pagination';
import Global from '~/styles/global';
import { useTranslation } from 'react-i18next';
import IsMobile from '~/services/mobileCheck';
import EventFullView from '../Events/view';
import { eventsRevenuesColumns } from '~/tables/eventsRevenues';
import Strong from '~/components/Strong';
import { formatPrice, parsePrice } from '~/Utils/format';

export default function EventsFinancials() {
  const { t } = useTranslation();
  const isMobile = IsMobile();
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]);
  const [page, setPage] = useState(1);
  const [perPage, setPerPage] = useState(10);
  const [meta, setMeta] = useState({});
  const [search, setSearch] = useState('');
  const [month, setMonth] = useState(null);
  const [year, setYear] = useState(null);
  const [modalVisible, setModalVisible] = useState(false);
  const [viewEvent, setViewEvent] = useState(null);

  const fetchData = async () => {
    setLoading(true);
    try {
      const params = {
        params: {
          page,
          perPage,
          search,
          month,
          year,
        },
      };
      const data = await getEventsFinancials(params);
      setData(data.data);
      setMeta(data.meta);
    } catch (error) {
      errorHandler(error);
    }
    setLoading(false);
  };

  const handleEdit = (record) => {
    setViewEvent(record);
    setModalVisible(true);
  };

  const currentYear = new Date().getFullYear();

  const years = Array.from({ length: currentYear - 2018 }, (_, i) => {
    const year = currentYear - i;
    return { value: year, label: year.toString() };
  });

  useEffect(() => {
    fetchData();
  }, [page, perPage, search, month, year]);

  return (
    <Box>
      <TableHeader>
        <Col style={{ display: 'flex' }}>
          <Select
            className="search-field"
            placeholder={t('Mês')}
            onChange={(value) => {
              setMonth(value);
              setPage(1);
            }}
            allowClear
            style={{ width: '400px' }}
            options={[
              { value: 1, label: 'Janeiro' },
              { value: 2, label: 'Fevereiro' },
              { value: 3, label: 'Março' },
              { value: 4, label: 'Abril' },
              { value: 5, label: 'Maio' },
              { value: 6, label: 'Junho' },
              { value: 7, label: 'Julho' },
              { value: 8, label: 'Agosto' },
              { value: 9, label: 'Setembro' },
              { value: 10, label: 'Outubro' },
              { value: 11, label: 'Novembro' },
              { value: 12, label: 'Dezembro' },
            ]}
          />
          <Select
            className="search-field"
            placeholder={t('Ano')}
            style={{ width: '100px' }}
            onSelect={(value) => {
              setYear(value);
              setPage(1);
            }}
            allowClear
            defaultValue={year}
            options={years}
          />
          <Input.Search
            onSearch={(value) => {
              setSearch(value);
              setPage(1);
            }}
            style={{ width: '100%' }}
            className="search-field"
            placeholder={t('screens:default.search')}
          />
        </Col>
      </TableHeader>
      <Table
        pagination={false}
        rowKey="id"
        loading={loading}
        dataSource={data}
        columns={eventsRevenuesColumns(handleEdit, isMobile)}
        bordered
        summary={() => {
          const totals = data?.reduce(
            (acc, er) => {
              acc.totalReceiptsTotal += parsePrice(er.total_receipts);
              acc.totalAgioTotal += parsePrice(er.total_agio);
              acc.totalLossesTotal += parsePrice(er.total_losses);
              acc.totalDrinksBrute += parsePrice(er.total_drinks_brute);
              acc.totalReceiptBrute += parsePrice(er.total_receipt_brute);
              acc.totalReceiptFinal += parsePrice(er.total_receipt_final);

              return acc;
            },
            {
              totalReceiptsTotal: 0,
              totalAgioTotal: 0,
              totalLossesTotal: 0,
              totalDrinksBrute: 0,
              totalReceiptBrute: 0,
              totalReceiptFinal: 0,
            }
          );

          return (
            <TableAntd.Summary.Row style={{ backgroundColor: '#d6d6d6' }}>
              <TableAntd.Summary.Cell>
                <Strong>{t('TOTAL')}</Strong>
              </TableAntd.Summary.Cell>
              <TableAntd.Summary.Cell />
              <TableAntd.Summary.Cell>{formatPrice(totals.totalReceiptsTotal)}</TableAntd.Summary.Cell>
              <TableAntd.Summary.Cell>{formatPrice(totals.totalAgioTotal)}</TableAntd.Summary.Cell>
              <TableAntd.Summary.Cell>{formatPrice(totals.totalLossesTotal)}</TableAntd.Summary.Cell>
              <TableAntd.Summary.Cell>{formatPrice(totals.totalDrinksBrute)}</TableAntd.Summary.Cell>
              <TableAntd.Summary.Cell>{formatPrice(totals.totalReceiptBrute)}</TableAntd.Summary.Cell>
              <TableAntd.Summary.Cell>{formatPrice(totals.totalReceiptFinal)}</TableAntd.Summary.Cell>
              <TableAntd.Summary.Cell />
            </TableAntd.Summary.Row>
          );
        }}
      />
      <Pagination
        isMobile={isMobile}
        onChange={(value) => {
          setPage(value);
        }}
        meta={meta}
        perPage={perPage}
        setPerPage={setPerPage}
      />
      <Global />
      <EventFullView
        visible={modalVisible}
        event={viewEvent}
        isMobile={isMobile}
        onClose={() => {
          setModalVisible(false);
          setViewEvent(null);
        }}
      />
    </Box>
  );
}
